import React from "react";
import styles from './modal-overlay.module.css';

function ModalOverlay({ children, handleCloseModal }) {

  const closeByClickOnlyOverlay = (e) => {
    if (e.target.classList.contains(styles.overlay)) {
      handleCloseModal();
    }
  }

  return (
    <div
      className={`${styles.overlay}`}
      onClick={closeByClickOnlyOverlay}
    >
      {children}
    </div>
  );
}

export default ModalOverlay;
